import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react'
import { useState } from 'react'
import { LiveAttendenceView, LocationShowdata } from '../../services/LoginPageService';
import NotificationBar from '../notification/ServiceNotificationBar';
import LiveTools from './LiveTools';
import { useEffect } from 'react';

const LiveList = () => {
    const[location,setLocation]=useState('');
    const[locationList,setLocationList]=useState([]);
    const [deviceId,setDeviceId] = useState('');
    const [userId,setUserId] = useState('');
    const [rows,setRow]=useState([]);
    const [openNotification, setNotification] = useState({
        status: false,
        type: 'error',
        message: '',
    });

    const isValidNumber = (input) => {
        return /^[0-9]*$/.test(input);
    };
    
    const handleDeviceIdChange = (e) => {
        const input = e.target.value;
        if (isValidNumber(input)) {
            setDeviceId(input);
        }
    };
    
    const handleUserIdChange = (e) => {
        const input = e.target.value;
        if (isValidNumber(input)) {
            setUserId(input);
        }
    };

    const columns = [
        // {
        //     field: 'date',
        //     headerName: 'Date',
        //     headerClassName: 'super-app-theme--header',
        //     minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        // },
        {
            field: 'UserId',
            headerName: 'User Id',
            headerClassName: 'super-app-theme--header',
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        },
        // {
        //     field: 'DeviceId',
        //     headerName: 'Device Id',
        //     headerClassName: 'super-app-theme--header',
        //     minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        // },
        {
            field: 'inTime',
            headerName: 'Login Time',
            headerClassName: 'super-app-theme--header',
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        },
        {
            field: 'outTime',
            headerName: 'Logout Time',
            headerClassName: 'super-app-theme--header',
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        },
    ];

    useEffect(()=>{
        LocationShowdata(handleLocationshow,handleLocationshowException);
    },[])

    const handleLocationshow=(dataObject)=>{
        setLocationList(dataObject?.data);
        console.log(dataObject?.data);
    }
    
    const handleLocationshowException=(error,errorMessage)=>{
        console.log(errorMessage);
    }

    const onViewData=()=>{
        LiveAttendenceView({
            location:location,
            deviceId: deviceId,
            userId  : userId,
        }, handleAttendenceView,handleAttendenceViewException);
    }

    const handleAttendenceView= (dataObject) =>{
        setRow(dataObject?.data);
        ClearForm();
    }

    const ClearForm=()=>{
        setLocation('');
        setDeviceId('');
        setUserId('');
    }

    const handleAttendenceViewException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
        setNotification({
            status: true,
            type: 'error',
            message: errorMessage,
        });
    }

    const handleCloseNotify = () => {
        setNotification({
        status: false,
        type: '',
        message: '',
        });                                                                                                                                                                                                                 
      };
    
    const onLocationChange=(e)=>{
        setLocation(e.target.value);
    }

    return (
        <div style={{ height: 520, width: '98%',overflow: "scroll" }}>
           <LiveTools />
            <Grid container spacing={3} >
                <Grid item xs={12} sm={3.6} md={3.6} lg={3.6} xl={3.6}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Location</InputLabel>
                        <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                        placeholder='Location'
                        value={location}
                        required
                        onChange={(e) => onLocationChange(e) }>
                        {
                            locationList?.map((data, index) => {
                                return (
                                    <MenuItem value={data.id} key={index}>{data.location}</MenuItem>
                                )
                            })
                        }      
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={3.6} md={3.6} lg={3.6} xl={3.6}>
                <TextField
                        fullWidth
                        label="Device Id"
                        placeholder='Device Id'
                        variant="outlined"
                        required
                        onChange={handleDeviceIdChange}
                        value={deviceId} />
                </Grid>
                <Grid item xs={12} sm={3.6} md={3.6} lg={3.6} xl={3.6}>
                    <TextField
                        fullWidth
                        label="User Id"
                        placeholder='User Id'
                        variant="outlined"
                        onChange={handleUserIdChange}
                        value={userId} />
                </Grid>
                <Grid item xs={12} sm={1} md={1} lg={1} xl={1} style={{}} >
                    <Button variant="contained" onClick={onViewData}>View</Button>
                </Grid>
            </Grid>
            <Grid style={{marginTop:'20px'}}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    sx={{
                    height: '100%',
                    minHeight: '480px',
                    width: '100%',
                    '& .super-app-theme--header': {
                        WebkitTextStrokeWidth:'0.6px',
                    },
                    }}
                    pageSize={10}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                />
            </Grid>
            <NotificationBar
                handleClose={handleCloseNotify}
                notificationContent={openNotification.message}
                openNotification={openNotification.status}
                type={openNotification.type}
            />
        </div>
    )
}

export default LiveList
